'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
  CANCELLATION_REQUESTED: 'CANCELLATION_REQUESTED',
  FILLED: 'FILLED',
  PARTIALLY_FILLED: 'PARTIALLY_FILLED',
  PENDING_CANCEL: 'PENDING_CANCEL',
  REJECTED: 'REJECTED',
  SENT: 'SENT'
};